import React from "react";
import { Link, Outlet } from "react-router-dom";
import { useDispatch } from "react-redux";
import btn_logout from "@/assets/btn_logout.png";
import { logout } from "@/redux/slices/userSlices";

const Root: React.FC = () => {
  const dispatch = useDispatch();
  return (
    <>
      <Outlet />
      {/* <div className="z-10 fixed bottom-0 right-0">
        <div className="flex gap-4 justify-end">
          <Link to={"/Manage/ChangePassword"} className="check-time-activated">
            Đổi mật khẩu
          </Link>
          <button className="w-[80%]" onClick={() => dispatch(logout())}>
            <img src={btn_logout} />
          </button>
        </div>
      </div> */}
    </>
  );
};

export default Root;
